import { isEqual } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWillUnMount } from '../../../../../../hooks/life-cycle';
import { CsvActions } from '../../../../../../redux/csv/csv.action';
import { State } from '../../../../../../redux/root.reducer';
import { DateFormatter } from '../../../../../../utilities/date-formatter';
import { Limit, TableSort } from '../../../../../ui/table/table-sort/table-sort';
import { CsvListLostOrder } from '../../list/lost-order/csv-list-lost-order';
import { CsvSearchBoxLostOrder } from '../../search-box/lost-order/csv-search-box-lost-order';
import { CsvLostOrderSort } from '../../../../../../type/csv/csv-sort.type';
import { CsvModel } from '../../../../../../model/csv/csv-model';
import { useAppSelector } from '../../../../../../hooks/use-redux';

type Props = {
  callback: (v: () => void) => void;
}

export const CsvLostOrder = (props:Props) => {
  const { callback } = props;

  /* Hooks */
  const dispatch = useDispatch();
  const sortState = useSelector((state: State) => (state.csv.lostOrderSort), isEqual);
  const list = useSelector((state: State) => (state.csv.lostOrderList), isEqual);
  const hitCount = useAppSelector((v) => (v.csv.lostOrderCount));

  /* State */
  const [selected, setSelected] = useState<number[]>([]);
  // eslint-disable-next-line
  const [searchIsOpen, setSearchIsOpen] = useState<boolean>(false);

  /* Callback */
  const getList = useCallback((v?: CsvLostOrderSort) => {
    const sortData = v || sortState;
    dispatch(CsvActions.api.lostOrder.getList(CsvModel.lostOrderEx(sortData)));
    setSelected([]);
  },
  [sortState]);

  const changePagination = useCallback((offset:number, limit:Limit) => {
    dispatch(CsvActions.setLostOrderList(null));
    dispatch(CsvActions.setLostOrderSort({ offset, limit }));
    getList({ ...sortState, offset, limit });
  }, []);

  /* Effect */
  useEffect(() => {
    getList();
  }, [
    sortState.highlow,
    sortState.sort_by,
  ]);

  return (
    <>
      <CsvSearchBoxLostOrder
        openCallback={setSearchIsOpen}
        callback={(v) => {
          dispatch(CsvActions.setLostOrderList(null));
          getList(v);
        }}
      />
      <TableSort
        page={sortState.offset ?? 0}
        limit={sortState.limit as Limit}
        hitCount={hitCount || 0}
        callback={changePagination}
      />
      <CsvListLostOrder
        callbackSelected={setSelected}
      />
      <TableSort
        className="bottom"
        page={sortState.offset ?? 0}
        limit={sortState.limit as Limit}
        hitCount={hitCount || 0}
        callback={changePagination}
      />
    </>
  );
};
